import { render, staticRenderFns } from "./DetailImageComponent.vue?vue&type=template&id=1236d876&"
import script from "./DetailImageComponent.vue?vue&type=script&lang=js&"
export * from "./DetailImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports